import { IEditDeviceContext } from './editDeviceContext';
import { IDeviceBankSettingForEdit } from 'types';

export enum EditDeviceActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_HARDWARE_ID = 'CHANGE_HARDWARE_ID',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_BANK_SETTINGS = 'SET_BANK_SETTINGS',
	ADD_BANK_SETTINGS_BLOCK = 'ADD_BANK_SETTINGS_BLOCK',
	SET_FETCHED_RESTAURANT_BANK_SETTINGS = 'SET_FETCHED_RESTAURANT_BANK_SETTINGS',
	SET_TLS_CERTIFICATE_LEVEL = 'SET_TLS_CERTIFICATE_LEVEL',
	CHANGE_TLS_CERTIFICATE_NAME = 'CHANGE_TLS_CERTIFICATE_NAME',
	SET_TLS_CERTIFICATE_FILE = 'SET_TLS_CERTIFICATE_FILE',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IRefetchData {
	type: EditDeviceActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IEditDeviceContext['needRefetchData'];
	};
}

interface ISetInitialFormData {
	type: EditDeviceActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IEditDeviceContext['initialFormData'];
	};
}

interface ISetAllData {
	type: EditDeviceActionTypes.SET_ALL_DATA;
	payload: {
		deviceId: IEditDeviceContext['deviceId'];
		hardwareId: IEditDeviceContext['hardwareId'];
		IDSelectedCustomer: IEditDeviceContext['IDSelectedCustomer'];
		IDSelectedRestaurant: IEditDeviceContext['IDSelectedRestaurant'];
		bankSettings: IEditDeviceContext['bankSettings'];
		availableRestaurantBankSettings: IEditDeviceContext['availableRestaurantBankSettings'];
		tlsCertificateName: IEditDeviceContext['tlsCertificateName'];
		tlsCertificateFilePath: IEditDeviceContext['tlsCertificateFilePath'];
		tlsCertificateFileId: IEditDeviceContext['tlsCertificateFileId'];
	};
}

interface IChangeHardwareId {
	type: EditDeviceActionTypes.CHANGE_HARDWARE_ID;
	payload: {
		hardwareId: IEditDeviceContext['hardwareId'];
	};
}

interface ISetFetchedCustomers {
	type: EditDeviceActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: IEditDeviceContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: EditDeviceActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IEditDeviceContext['IDSelectedCustomer'];
	};
}

interface ISetFetchedRestaurants {
	type: EditDeviceActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IEditDeviceContext['fetchedRestaurants'];
	};
}

interface ISetIDRestaurant {
	type: EditDeviceActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IEditDeviceContext['IDSelectedRestaurant'];
	};
}

interface ISetBankSettings {
	type: EditDeviceActionTypes.SET_BANK_SETTINGS;
	payload: {
		bankSettings: IEditDeviceContext['bankSettings'];
	};
}

interface IAddBankSettingsBlock {
	type: EditDeviceActionTypes.ADD_BANK_SETTINGS_BLOCK;
	payload: {
		bankSettings: IDeviceBankSettingForEdit;
	};
}

interface ISetFetchedRestaurantBankSettings {
	type: EditDeviceActionTypes.SET_FETCHED_RESTAURANT_BANK_SETTINGS;
	payload: {
		fetchedRestaurantBankSettings: IEditDeviceContext['fetchedRestaurantBankSettings'];
	};
}

interface ISetTlsCertificateLevel {
	type: EditDeviceActionTypes.SET_TLS_CERTIFICATE_LEVEL;
	payload: {
		tlsCertificateLevel: IEditDeviceContext['tlsCertificateLevel'];
		tlsCertificateName: IEditDeviceContext['tlsCertificateName'];
		tlsCertificateFilePath: IEditDeviceContext['tlsCertificateFilePath'];
		tlsCertificateFileId: IEditDeviceContext['tlsCertificateFileId'];
		tlsCertificateFileHash: IEditDeviceContext['tlsCertificateFileHash'];
	};
}

interface IChangeTlsCertificateName {
	type: EditDeviceActionTypes.CHANGE_TLS_CERTIFICATE_NAME;
	payload: {
		tlsCertificateName: IEditDeviceContext['tlsCertificateName'];
	};
}

interface ISetTlsCertificateFile {
	type: EditDeviceActionTypes.SET_TLS_CERTIFICATE_FILE;
	payload: {
		tlsCertificateFileId: IEditDeviceContext['tlsCertificateFileId'];
		tlsCertificateFileHash: IEditDeviceContext['tlsCertificateFileHash'];
	};
}

interface ISetDataForSubmit {
	type: EditDeviceActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditDeviceContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditDeviceActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditDeviceContext['typeOfModalWindow'];
	};
}

interface IShowErrorModalWithInfo {
	type: EditDeviceActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IEditDeviceContext['errorResponseData'];
	};
}

interface IResetSelectedControls {
	type: EditDeviceActionTypes.RESET_FIELDS;
}

export type TEditDeviceAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IChangeHardwareId
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDRestaurant
	| ISetBankSettings
	| IAddBankSettingsBlock
	| ISetFetchedRestaurantBankSettings
	| ISetTlsCertificateLevel
	| IChangeTlsCertificateName
	| ISetTlsCertificateFile
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| IResetSelectedControls;
